// @ts-nocheck
/**
 * ツインキーシステム - 固有パッシブ定義
 *
 * 高ティア（S/A/B）カードに個別設定される固有パッシブ
 * 仕様書: twin_key_generic_skills_passives_v1.md
 *
 * 固有パッシブ持ちカードはパッシブ決定の最優先順位を持つ
 * 優先順位: 固有 → 属性×カテゴリ汎用
 */

import { PASSIVE_EFFECT_TYPES, PASSIVE_CONDITIONS } from './attributePassives';

// ========================================
// 固有パッシブ定義
// カードID → パッシブ配列のマップ
// ========================================

/**
 * 固有パッシブマップ
 * キー: カードID
 * 値: パッシブ配列（最大4つ、slot 1-4）
 *
 * 将来的にTier S/A/Bカードに個別パッシブを設定
 */
export const UNIQUE_PASSIVES = {
  // ========================================
  // サンプル: 固有パッシブ持ちカード
  // ========================================

  // 例: C0000001 - 炎竜フレアドラゴン（Tier S想定）
  // C0000001: [
  //   {
  //     id: 'unique_C0000001_1',
  //     name: '炎竜の威厳',
  //     description: '攻撃力+15%、HP+10%',
  //     slot: 1,
  //     effects: [
  //       { type: PASSIVE_EFFECT_TYPES.ATK_PERCENT, value: 15 },
  //       { type: PASSIVE_EFFECT_TYPES.HP_PERCENT, value: 10 },
  //     ],
  //   },
  //   {
  //     id: 'unique_C0000001_2',
  //     name: '灼熱のオーラ',
  //     description: '味方全体の攻撃+8%、敵全体の防御-5%',
  //     slot: 2,
  //     effects: [
  //       { type: PASSIVE_EFFECT_TYPES.ALLY_BUFF, stat: 'atk', value: 8 },
  //       { type: 'enemy_debuff_aura', stat: 'def', value: -5 },
  //     ],
  //   },
  //   {
  //     id: 'unique_C0000001_3',
  //     name: '業火の支配者',
  //     description: '火傷状態の敵に与ダメ+30%、攻撃時30%で火傷付与',
  //     slot: 3,
  //     effects: [
  //       { type: PASSIVE_EFFECT_TYPES.STATUS_DAMAGE, status: 'burn', value: 30 },
  //       { type: PASSIVE_EFFECT_TYPES.ON_ATTACK, chance: 30, effect: { type: 'status', status: 'burn' } },
  //     ],
  //   },
  //   {
  //     id: 'unique_C0000001_ult',
  //     name: '炎帝の覚醒',
  //     description: 'HP50%以下で攻撃力+50%、攻撃時確定火傷',
  //     slot: 4,
  //     isUltimate: true,
  //     effects: [
  //       { type: PASSIVE_EFFECT_TYPES.CONDITIONAL_ATK, value: 50, condition: PASSIVE_CONDITIONS.HP_BELOW, threshold: 50 },
  //       { type: PASSIVE_EFFECT_TYPES.ON_ATTACK, chance: 100, effect: { type: 'status', status: 'burn' } },
  //     ],
  //   },
  // ],
};

// ========================================
// ヘルパー関数
// ========================================

/**
 * カードが固有パッシブを持つか確認
 * @param {string} cardId - カードID
 * @returns {boolean} 固有パッシブを持つ場合true
 */
export const hasUniquePassives = (cardId) => {
  return cardId in UNIQUE_PASSIVES && UNIQUE_PASSIVES[cardId].length > 0;
};

/**
 * カードの固有パッシブを取得
 * @param {string} cardId - カードID
 * @returns {Object[]|null} パッシブ配列、なければnull
 */
export const getUniquePassives = (cardId) => {
  if (!hasUniquePassives(cardId)) return null;
  return UNIQUE_PASSIVES[cardId];
};

/**
 * 固有パッシブを登録
 * 動的にパッシブを追加する場合に使用
 * @param {string} cardId - カードID
 * @param {Object[]} passives - パッシブ配列
 */
export const registerUniquePassives = (cardId, passives) => {
  UNIQUE_PASSIVES[cardId] = passives;
};

/**
 * 固有パッシブを削除
 * @param {string} cardId - カードID
 */
export const unregisterUniquePassives = (cardId) => {
  delete UNIQUE_PASSIVES[cardId];
};

/**
 * 登録済み固有パッシブのカードID一覧を取得
 * @returns {string[]} カードID配列
 */
export const getUniquePassiveCardIds = () => {
  return Object.keys(UNIQUE_PASSIVES).filter(id => UNIQUE_PASSIVES[id].length > 0);
};

export default {
  UNIQUE_PASSIVES,
  hasUniquePassives,
  getUniquePassives,
  registerUniquePassives,
  unregisterUniquePassives,
  getUniquePassiveCardIds,
};
